(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nutrilea-landing-pl"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(scope){
    var root = scope.getElementById ? scope.getElementById('nl-root') : scope.querySelector('#nl-root');
    if(!root || root.dataset.nlInit) return; root.dataset.nlInit = '1';
    var offers = root.querySelectorAll('.nl-offer');
    var input  = root.querySelector('#nl-variant');
    function select(el){
      offers.forEach(function(o){
        o.style.borderColor = 'var(--line)';
        o.style.boxShadow = 'none';
        var d = o.querySelector('.nl-dot'); if(d) d.style.display = 'none';
      });
      el.style.borderColor = 'var(--brand)';
      el.style.boxShadow = '0 10px 26px -14px var(--brand)';
      var dot = el.querySelector('.nl-dot'); if(dot) dot.style.display = 'block';
      var v = el.getAttribute('data-variant'); if(v && input) input.value = v;
      var sp = root.querySelector('#nl-sticky-price'); var pr = el.querySelector('.nl-card-price');
      if(sp && pr){ sp.textContent = pr.textContent.trim(); }
      var g = root.querySelector('#nl-gifts'); if(g){ g.classList.toggle('locked', el.getAttribute('data-index') === '1'); }
    }
    offers.forEach(function(o){ o.addEventListener('click', function(){ select(o); }); });
    var active = root.querySelector('.nl-offer.nl-active'); if(active) select(active);

    var cd = root.querySelector('#nl-cd');
    var cutoff = parseInt(root.getAttribute('data-cutoff') || '18', 10);
    function tick(){
      if(!cd) return;
      var now = new Date();
      var end = new Date(now); end.setHours(cutoff, 0, 0, 0);
      if(end < now){ end.setDate(end.getDate() + 1); }
      var diff = Math.max(0, end - now);
      var h = Math.floor(diff / 3600000), m = Math.floor((diff % 3600000) / 60000);
      cd.textContent = h + ' h ' + (m < 10 ? '0' + m : m) + ' min';
    }
    tick(); setInterval(tick, 60000);

    // --- custom slide cart ---
    var form = root.querySelector('#nl-buyform');
    var drawer = document.getElementById('nl-cart');
    var overlay = document.getElementById('nl-cart-overlay');
    var itemsEl = document.getElementById('nl-cart-items');
    var totalEl = document.getElementById('nl-cart-total');
    function money(c){ return (c/100).toFixed(2).replace('.', ',') + ' zł'; }
    function openDrawer(){ if(overlay){ overlay.style.opacity='1'; overlay.style.visibility='visible'; } if(drawer){ drawer.style.transform='translateX(0)'; } document.body.style.overflow='hidden'; }
    function closeDrawer(){ if(overlay){ overlay.style.opacity='0'; overlay.style.visibility='hidden'; } if(drawer){ drawer.style.transform='translateX(100%)'; } document.body.style.overflow=''; }
    function renderCart(cart){
      if(!itemsEl) return;
      if(!cart.items || !cart.items.length){ itemsEl.innerHTML = '<p style="text-align:center;color:#5f706f;padding:36px 0;font:500 14px Hanken Grotesk;">Twój koszyk jest pusty.</p>'; }
      else {
        itemsEl.innerHTML = cart.items.map(function(it){
          var img = it.image ? '<img src="'+it.image+'" alt="" style="width:60px;height:60px;object-fit:cover;border-radius:10px;flex:0 0 auto;border:1px solid var(--line);">' : '';
          return '<div style="display:flex;gap:12px;align-items:center;padding:11px 0;border-bottom:1px solid var(--line);">'+img+
            '<div style="flex:1 1 0;min-width:0;"><div style="font:700 14px Hanken Grotesk;color:var(--ink);">'+it.product_title+'</div>'+
            '<div style="font:500 12px Hanken Grotesk;color:var(--muted);">'+(it.variant_title && it.variant_title!=='Default Title' ? it.variant_title+' &middot; ' : '')+'Szt. '+it.quantity+'</div></div>'+
            '<div style="font:800 14px Hanken Grotesk;color:var(--ink);white-space:nowrap;">'+money(it.final_line_price)+'</div></div>';
        }).join('');
      }
      if(totalEl) totalEl.textContent = money(cart.total_price);
    }
    function refreshCart(){ fetch('/cart.js', {headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(renderCart).catch(function(){}); }
    var adding = false;
    function addToCart(){
      var idEl = root.querySelector('#nl-variant');
      var vid = idEl && idEl.value ? idEl.value : '';
      if(!vid || adding){ return; }
      adding = true;
      fetch('/cart/add.js', {method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body: JSON.stringify({items:[{id: vid, quantity: 1}]})})
        .then(function(r){ if(!r.ok){ throw new Error('add'); } return r.json(); })
        .then(function(){ adding = false; refreshCart(); openDrawer(); })
        .catch(function(){ adding = false; window.location.href = '/cart/' + vid + ':1'; });
    }
    if(form){ form.addEventListener('submit', function(e){ e.preventDefault(); addToCart(); }); }
    var addMain = root.querySelector('#nl-add-main'); if(addMain){ addMain.addEventListener('click', function(e){ e.preventDefault(); addToCart(); }); }
    var addSticky = document.getElementById('nl-add-sticky'); if(addSticky){ addSticky.addEventListener('click', function(e){ e.preventDefault(); addToCart(); }); }
    var cc = document.getElementById('nl-cart-close'); if(cc){ cc.addEventListener('click', closeDrawer); }
    if(overlay){ overlay.addEventListener('click', closeDrawer); }
    document.addEventListener('keydown', function(e){ if(e.key === 'Escape'){ closeDrawer(); } });
    var co = document.getElementById('nl-cart-checkout'); if(co){ co.addEventListener('click', function(){ window.location.href = '/checkout'; }); }
    var ctimer = document.getElementById('nl-cart-timer');
    if(ctimer){ var secs = 15*60; setInterval(function(){ if(secs>0){ secs--; } var m=Math.floor(secs/60), s=secs%60; ctimer.textContent = m+':'+(s<10?'0'+s:s); }, 1000); }
  }
  if(document.readyState !== 'loading') init(document);
  else document.addEventListener('DOMContentLoaded', function(){ init(document); });
  // re-init inside the Shopify theme editor when the section is reloaded
  document.addEventListener('shopify:section:load', function(e){ init(e.target); });
})();

  } catch(e) { console.error(e); }
})();
})();
